import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";
import MarketGrowthAdminApi from "../../../../../infrastructure/api/marketGrowthAdmin";
import MarketGrowthDataTable from "./MarketGrowthDataTable";

const TeamShareHistoryDialog = ({ open, onClose, parentPartnerId, childPartnerId }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [items, setItems] = useState([]);

  const load = useCallback(async () => {
    if (!parentPartnerId || !childPartnerId) return;
    setLoading(true);
    setError(null);
    try {
      const res = await MarketGrowthAdminApi.getTeamShareHistory({
        parentPartnerId,
        childPartnerId,
      });
      const normalized = MarketGrowthAdminApi.normalize(
        res,
        "بارگذاری تاریخچه سهم ناموفق بود."
      );
      if (normalized.error) {
        setError(normalized.error);
        setItems([]);
        return;
      }
      setItems(Array.isArray(normalized.data) ? normalized.data : []);
    } catch (e) {
      setError(e?.message || "خطا در بارگذاری");
    } finally {
      setLoading(false);
    }
  }, [parentPartnerId, childPartnerId]);

  useEffect(() => {
    if (open) load();
  }, [open, load]);

  const tableRows = useMemo(
    () =>
      items.map((row) => ({
        ...row,
        statusLabel: row.isActive ? "فعال" : "غیرفعال",
      })),
    [items]
  );

  const headCells = useMemo(
    () => [
      { id: "sharePercentOfParentCommission", label: "سهم (%)" },
      { id: "effectiveFrom", label: "از تاریخ", type: "date" },
      { id: "effectiveTo", label: "تا تاریخ", type: "date" },
      {
        id: "statusLabel",
        label: "وضعیت",
        render: (_, row) => (
          <Chip
            size="small"
            label={row.isActive ? "فعال" : "غیرفعال"}
            color={row.isActive ? "success" : "default"}
          />
        ),
      },
      { id: "createdAt", label: "تاریخ ثبت", type: "date" },
    ],
    []
  );

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>تاریخچه سهم پورسانت</DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Box color="error.main">{error}</Box>
        ) : (
          <MarketGrowthDataTable
            rowKey="id"
            rows={tableRows}
            headCells={headCells}
            showFilter={false}
            showIndex={false}
            showPaging={items.length > 10}
            pageSize={100}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>بستن</Button>
      </DialogActions>
    </Dialog>
  );
};

export default TeamShareHistoryDialog;
